<div class="desktop-width-limiter overview-page">
  <div class="row overview-items">
    @for (streapper of streappers; track streapper; let i = $index) {
    <div
      class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 col-xxl-2 overview-item"
    >
      <user-card
        [streapper]="streapper"
        [ownProfile]="profile?.id === streapper.id"
        [rank]="i + 1"
      ></user-card>
    </div>
    }
  </div>
</div>
